/**
 * Dashboard-wide config values. Kept in one place (rather than scattered inside
 * component / styled files) so they're easy to find and tune.
 */

import type { Variants } from "motion/react";

import {
  MOTION_EASE_STANDARD,
  RydeUiUnit,
  UI_TRANSITION_SECONDS,
} from "@ryde/shared";

/** Opacity applied to a card while it is being dragged (the dnd-kit drag source). */
export const DRAGGING_CARD_OPACITY = 0.4;
export const REPORT_FILTER_ENTITY = "report" as RydeUiUnit;

export const DASHBOARD_GRID_APPEAR_VARIANTS: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.06,
    },
  },
};

export const DASHBOARD_CARD_APPEAR_VARIANTS: Variants = {
  hidden: { opacity: 0, y: 14 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: UI_TRANSITION_SECONDS.dashboardCardAppear,
      ease: [...MOTION_EASE_STANDARD],
    },
  },
};
